const PieChart = ({ ...props }) => {
  return (
    <svg width="24" height="24" x="0" y="0" viewBox="0 0 24 24" {...props}>
      {' '}
      <g>
        {' '}
        <path d="m19.25 0h-14.5c-1.517 0-2.75 1.233-2.75 2.75v18.5c0 1.517 1.233 2.75 2.75 2.75h14.5c1.517 0 2.75-1.233 2.75-2.75v-18.5c0-1.517-1.233-2.75-2.75-2.75zm-8.5 13v-4.924c2.4.365 4.25 2.424 4.25 4.924 0 2.757-2.243 5-5 5-1.108 0-2.123-.374-2.953-.987l3.483-3.483c.141-.14.22-.331.22-.53zm-1.5-4.924v4.614l-3.263 3.263c-.613-.83-.987-1.845-.987-2.953 0-2.5 1.85-4.559 4.25-4.924zm9 13.174h-12.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12.5c.414 0 .75.336.75.75s-.336.75-.75.75zm0-3.25h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75zm0-2.75h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75zm0-3h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75zm0-2.75h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75z"></path>{' '}
      </g>{' '}
    </svg>
  );
};

export default PieChart;
